var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEspecificas(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 93.317,
    height: 60.281,
    viewBox: "0 0 93.317 93.281",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1639",
    "data-name": "Grupo 1639",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_582",
    "data-name": "Trazado 582",
    d: "M960.336,130.732l3.082-.138c-.059-1.108-.11-2.076-.165-3.112l-2.916.249Z",
    transform: "translate(-891.185 -86.863)",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_583",
    "data-name": "Trazado 583",
    d: "M959.354,164.012c-.088,1.01-.169,1.955-.258,2.978l3.023.343c.1-1.054.192-2.035.292-3.093l-3.057-.228",
    transform: "translate(-890.351 -111.451)",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_584",
    "data-name": "Trazado 584",
    d: "M816.409,127.263l-2.882-.221c-.075,1.068-.144,2.043-.219,3.1h3.1Z",
    transform: "translate(-792.223 -86.567)",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_585",
    "data-name": "Trazado 585",
    d: "M813.793,164.063c.1,1.049.19,2,.29,3.055l3.028-.317c-.1-1.06-.182-2-.273-3l-3.045.262",
    transform: "translate(-792.549 -111.309)",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_586",
    "data-name": "Trazado 586",
    d: "M824.3,217.9l1.067,2.935,2.834-1.1-1.009-2.791-2.892.959",
    transform: "translate(-799.62 -147.074)",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_587",
    "data-name": "Trazado 587",
    d: "M814.738,111.475l3.021.348c.126-1.014.241-1.935.371-2.975l-3.026-.423c-.127,1.06-.238,1.985-.366,3.05",
    transform: "translate(-793.185 -74.036)",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_588",
    "data-name": "Trazado 588",
    d: "M817.477,92.979l2.976.569.608-2.931-2.977-.659-.607,3.021",
    transform: "translate(-795.029 -61.606)",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_589",
    "data-name": "Trazado 589",
    d: "M907.492,276.71l-1.553-2.635-2.487,1.173,1.008,2.869,3.031-1.407",
    transform: "translate(-852.898 -185.532)",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_590",
    "data-name": "Trazado 590",
    d: "M949.633,220.973l1.033-2.961-2.874-.934-1.006,2.779,2.846,1.116",
    transform: "translate(-882.066 -147.169)",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_591",
    "data-name": "Trazado 591",
    d: "M886.274,282.454h3.394c-.133-1.054-.255-2.021-.372-2.95h-2.688l-.334,2.95",
    transform: "translate(-841.335 -189.187)",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_592",
    "data-name": "Trazado 592",
    d: "M952.443,202.661l2.939.825.742-3.039-2.969-.64-.712,2.855",
    transform: "translate(-885.873 -135.543)",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_593",
    "data-name": "Trazado 593",
    d: "M913.534,14.244l1.944-2.366-2.687-1.887-1.549,2.636,2.292,1.617",
    transform: "translate(-858.141 -7.781)",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_594",
    "data-name": "Trazado 594",
    d: "M943.476,235,940.7,233.74l-1.309,2.643,2.678,1.434,1.4-2.813",
    transform: "translate(-877.09 -158.384)",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_595",
    "data-name": "Trazado 595",
    d: "M848.276,26.362l1.862-2.214-2.206-2.1-2.064,2.46,2.408,1.85",
    transform: "translate(-814.139 -15.9)",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_596",
    "data-name": "Trazado 596",
    d: "M924.421,24.566l1.871,2.217,2.431-1.85L926.64,22.5l-2.219,2.068",
    transform: "translate(-867.012 -16.199)",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_597",
    "data-name": "Trazado 597",
    d: "M837.123,37.317l-1.59,2.742,2.675,1.428,1.481-2.518-2.566-1.651",
    transform: "translate(-807.182 -26.174)",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_598",
    "data-name": "Trazado 598",
    d: "M939.239,40.521l-1.594-2.726-2.56,1.631,1.479,2.537,2.675-1.442",
    transform: "translate(-874.19 -26.496)",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_599",
    "data-name": "Trazado 599",
    d: "M830.467,58.111l1.159-2.726-2.782-1.263-1.2,2.894,2.824,1.1",
    transform: "translate(-801.872 -37.485)",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_600",
    "data-name": "Trazado 600",
    d: "M824.606,75.552l.859-2.844-2.883-.951-.916,2.979,2.941.816",
    transform: "translate(-797.848 -49.355)",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_601",
    "data-name": "Trazado 601",
    d: "M819.348,184.8c-.182-1.047-.341-1.959-.511-2.933l-3,.438.532,3.067,2.982-.573",
    transform: "translate(-793.923 -123.469)",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_602",
    "data-name": "Trazado 602",
    d: "M947.414,57.469l-1.227-2.891-2.777,1.268,1.181,2.722,2.822-1.1",
    transform: "translate(-879.793 -37.792)",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_603",
    "data-name": "Trazado 603",
    d: "M820.065,203.26l2.948-.813-.751-2.9-2.944.7.747,3.007",
    transform: "translate(-796.268 -135.372)",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_604",
    "data-name": "Trazado 604",
    d: "M932.3,253.667l1.815-2.617-2.565-1.631-1.662,2.385,2.413,1.863",
    transform: "translate(-870.693 -168.937)",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_605",
    "data-name": "Trazado 605",
    d: "M960.015,182.483l-3.024-.383-.466,2.92,2.982.539.508-3.076",
    transform: "translate(-888.62 -123.625)",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_606",
    "data-name": "Trazado 606",
    d: "M917.927,265.236l1.927,2.351,2.365-2.2-2.2-2.106-2.092,1.954",
    transform: "translate(-862.641 -178.268)",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_607",
    "data-name": "Trazado 607",
    d: "M870.168,278.032l1.007-2.874-2.492-1.17-1.535,2.65,3.02,1.394",
    transform: "translate(-828.462 -185.474)",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_608",
    "data-name": "Trazado 608",
    d: "M955.327,94.036l2.993-.574-.644-3.021-2.969.679.62,2.917",
    transform: "translate(-887.397 -61.931)",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_609",
    "data-name": "Trazado 609",
    d: "M832.552,237.708l2.673-1.439-1.306-2.644L831.15,234.9l1.4,2.809",
    transform: "translate(-804.232 -158.306)",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_610",
    "data-name": "Trazado 610",
    d: "M899.464,4.153l-3.3-.715-.337,3.013,2.629.595,1.01-2.894",
    transform: "translate(-847.764 -3.37)",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_611",
    "data-name": "Trazado 611",
    d: "M863.527,12.387,861.981,9.75,859.3,11.622,861.22,14l2.307-1.609",
    transform: "translate(-823.177 -7.619)",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_612",
    "data-name": "Trazado 612",
    d: "M842.716,249.293l-2.576,1.636,1.822,2.6,2.416-1.846-1.662-2.392",
    transform: "translate(-810.283 -168.852)",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_613",
    "data-name": "Trazado 613",
    d: "M854.094,263.2l-2.216,2.1,2.373,2.189,1.926-2.344-2.082-1.95",
    transform: "translate(-818.183 -178.214)",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_614",
    "data-name": "Trazado 614",
    d: "M950.8,76.042l2.932-.834-.9-2.979-2.878.962.844,2.851",
    transform: "translate(-884.2 -49.673)",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_615",
    "data-name": "Trazado 615",
    d: "M961.041,108.909l-3.019.447c.135,1.066.25,1.977.373,2.947l3.006-.332-.359-3.062",
    transform: "translate(-889.628 -74.361)",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_616",
    "data-name": "Trazado 616",
    d: "M879.928,3.231l-3.309.779,1.008,2.856,2.6-.575c-.092-.953-.183-1.9-.3-3.059",
    transform: "translate(-834.837 -3.231)",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_231",
    "data-name": "Rect\\xE1ngulo 231",
    width: 2.915,
    height: 2.913,
    transform: "translate(21.143 46.672)",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_232",
    "data-name": "Rect\\xE1ngulo 232",
    width: 2.886,
    height: 2.951,
    transform: "translate(69.29 46.698)",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_617",
    "data-name": "Trazado 617",
    d: "M877.336,100.794c0,4.46,0,8.85,0,13.239a4.465,4.465,0,0,1-4.769,4.747q-2.775,0-5.55,0a4.463,4.463,0,0,1-4.728-4.693q-.006-6.116,0-12.232v-1.013c-2.328-.581-3.01-1.462-3.01-3.836,0-2.039.047-4.079-.01-6.116a10.725,10.725,0,0,1,5.577-10.065,7.667,7.667,0,0,1-2.453-7.091,7.309,7.309,0,0,1,2.885-4.686,7.558,7.558,0,0,1,9.806.631c3.073,3.011,2.992,6.675-.261,11.192a10.435,10.435,0,0,1,5.421,7.81,28.037,28.037,0,0,1,.1,3.849c.013,1.568,0,3.136,0,4.7,0,2.138-.848,3.161-3.01,3.56m-6.021,14.887c2.452.308,3.013-.169,3.013-2.465,0-4.14.01-8.279-.007-12.419a2.791,2.791,0,0,1,1.157-2.441,9.624,9.624,0,0,1,1.691-.791c0-2.928.219-5.859-.056-8.743-.335-3.509-3.722-6.174-7.311-6.168s-6.962,2.669-7.294,6.186c-.276,2.912-.057,5.871-.057,8.824a3.048,3.048,0,0,1,2.844,3.438c0,4.265-.006,8.53,0,12.8a1.626,1.626,0,0,0,1.825,1.872c.367.008.733,0,1.2,0V103.8h2.991ZM865.3,75.093a4.506,4.506,0,1,0,4.515-4.476,4.59,4.59,0,0,0-4.515,4.476",
    transform: "translate(-823.153 -46.514)",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_618",
    "data-name": "Trazado 618",
    d: "M759.456,27.387v-2.9l-3.868-1.594-1.88,2.192-2.237-2.471,2.006-1.815-1.6-3.887h-2.91v-2.98h2.889l1.606-3.907-2.2-1.885L753.75,5.9l1.819,2.014,3.88-1.6V3.408h2.979V6.3l3.9,1.6,1.892-2.21,2.243,2.512L768.41,9.932l1.63,3.958h2.906v2.979h-2.891l-1.6,3.9,2.208,1.894-2.494,2.224-1.818-2-3.878,1.6v2.906Zm7.519-11.958a6.017,6.017,0,1,0-6.1,5.99,6.1,6.1,0,0,0,6.1-5.99",
    transform: "translate(-748.919 -3.35)",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_619",
    "data-name": "Trazado 619",
    d: "M967.286,7.952l3.955-1.632v-2.9h2.979V6.308L978.2,7.94l1.864-2.247,2.323,2.346L980.23,10l1.6,3.893h2.9V16.87H981.85l-1.634,3.98,2.25,1.87-2.378,2.346-1.862-2.212-3.959,1.633v2.9h-2.979V24.5l-3.979-1.638-1.872,2.252L963.1,22.741l2.208-1.864-1.626-3.961H960.77V13.937h2.886l1.637-3.984-2.259-1.874,2.421-2.292,1.831,2.166m11.484,7.462a6.018,6.018,0,1,0-12.035-.024,6.018,6.018,0,1,0,12.035.024",
    transform: "translate(-891.478 -3.356)",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_620",
    "data-name": "Trazado 620",
    d: "M982.5,234.528,980.1,236.8l-1.838-2.112-3.967,1.641v2.9h-3.012v-2.893l-3.9-1.6-1.9,2.26-2.29-2.367,2.144-1.883-1.634-3.971h-2.906v-3.012h2.892l1.6-3.917-2.277-1.888,2.4-2.242,1.921,2.076,3.919-1.62v-2.9h3.013v2.9l3.915,1.6,1.891-2.276,2.235,2.393-2.071,1.928,1.618,3.913h2.9v3.012h-2.895l-1.6,3.912,2.255,1.874m-9.779-1.255a6.021,6.021,0,1,0-5.977-6.014,6.1,6.1,0,0,0,5.977,6.014",
    transform: "translate(-891.49 -145.953)",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_621",
    "data-name": "Trazado 621",
    d: "M766.357,234.776l-3.812,1.57v2.9h-3.013v-2.878l-3.852-1.573-1.909,2.257-2.376-2.5,2.138-1.867-1.6-3.865h-2.9v-3.013h2.876l1.582-3.878-2.274-1.869,2.5-2.39,1.933,2.113,3.809-1.582v-2.9h3.012v2.878l3.84,1.57,1.92-2.245L770.612,220l-2.143,1.876,1.6,3.861h2.9v3.012h-2.879l-1.575,3.863,2.282,1.9-2.553,2.325-1.886-2.063m.659-7.514a6.018,6.018,0,1,0-6.052,6.035,6.1,6.1,0,0,0,6.052-6.035",
    transform: "translate(-748.961 -145.977)",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_622",
    "data-name": "Trazado 622",
    d: "M748.81,113.65a4.513,4.513,0,1,1,4.381,4.548,4.474,4.474,0,0,1-4.381-4.548m6.007.079a1.494,1.494,0,1,0-1.563,1.449,1.573,1.573,0,0,0,1.563-1.449",
    transform: "translate(-748.81 -74.536)",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_623",
    "data-name": "Trazado 623",
    d: "M1011.215,109.167a4.515,4.515,0,1,1-4.571,4.458,4.465,4.465,0,0,1,4.571-4.458m-.086,3.016a1.5,1.5,0,1,0,1.521,1.493,1.583,1.583,0,0,0-1.521-1.493",
    transform: "translate(-922.355 -74.535)",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_624",
    "data-name": "Trazado 624",
    d: "M988.177,159.826a4.515,4.515,0,1,1-4.554,4.473,4.476,4.476,0,0,1,4.554-4.473m1.453,4.54a1.495,1.495,0,1,0-1.544,1.468,1.582,1.582,0,0,0,1.544-1.468",
    transform: "translate(-906.859 -108.633)",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_625",
    "data-name": "Trazado 625",
    d: "M776.378,159.824a4.514,4.514,0,1,1-4.548,4.38,4.476,4.476,0,0,1,4.548-4.38m1.459,4.525a1.5,1.5,0,1,0-1.529,1.485,1.578,1.578,0,0,0,1.529-1.485",
    transform: "translate(-764.305 -108.631)",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_626",
    "data-name": "Trazado 626",
    d: "M960.336,130.732v-3l2.916-.249c.055,1.036.106,2,.165,3.112l-3.082.138",
    transform: "translate(-891.185 -86.863)",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_627",
    "data-name": "Trazado 627",
    d: "M959.354,164.012l3.057.228c-.1,1.058-.193,2.039-.292,3.093l-3.023-.343c.089-1.023.171-1.968.258-2.978",
    transform: "translate(-890.351 -111.451)",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_628",
    "data-name": "Trazado 628",
    d: "M816.409,127.263v2.883h-3.1c.075-1.061.144-2.036.219-3.1l2.882.221",
    transform: "translate(-792.223 -86.567)",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_629",
    "data-name": "Trazado 629",
    d: "M813.793,164.063l3.045-.262c.091,1,.177,1.94.273,3l-3.028.317c-.1-1.055-.191-2.006-.29-3.055",
    transform: "translate(-792.549 -111.309)",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_630",
    "data-name": "Trazado 630",
    d: "M824.3,217.9l2.892-.959,1.009,2.791-2.834,1.1L824.3,217.9",
    transform: "translate(-799.62 -147.074)",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_631",
    "data-name": "Trazado 631",
    d: "M814.738,111.475c.128-1.065.239-1.99.366-3.05l3.026.423c-.13,1.04-.245,1.96-.371,2.975l-3.021-.348",
    transform: "translate(-793.185 -74.036)",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_632",
    "data-name": "Trazado 632",
    d: "M817.477,92.979l.607-3.021,2.977.659-.608,2.931-2.976-.569",
    transform: "translate(-795.029 -61.606)",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_633",
    "data-name": "Trazado 633",
    d: "M907.492,276.71l-3.031,1.407-1.008-2.869,2.487-1.173,1.553,2.635",
    transform: "translate(-852.898 -185.532)",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_634",
    "data-name": "Trazado 634",
    d: "M949.633,220.973l-2.846-1.116,1.006-2.779,2.874.934-1.033,2.961",
    transform: "translate(-882.066 -147.169)",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_635",
    "data-name": "Trazado 635",
    d: "M886.274,282.454l.334-2.95H889.3c.117.93.239,1.9.372,2.95Z",
    transform: "translate(-841.335 -189.187)",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_636",
    "data-name": "Trazado 636",
    d: "M952.443,202.661l.712-2.855,2.969.64-.742,3.039-2.939-.825",
    transform: "translate(-885.873 -135.543)",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_637",
    "data-name": "Trazado 637",
    d: "M913.534,14.244l-2.292-1.617,1.549-2.636,2.687,1.887-1.944,2.366",
    transform: "translate(-858.141 -7.781)",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_638",
    "data-name": "Trazado 638",
    d: "M943.476,235l-1.4,2.813-2.678-1.434,1.309-2.643L943.476,235",
    transform: "translate(-877.09 -158.384)",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_639",
    "data-name": "Trazado 639",
    d: "M848.276,26.362l-2.408-1.85,2.064-2.46,2.206,2.1-1.862,2.214",
    transform: "translate(-814.139 -15.9)",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_640",
    "data-name": "Trazado 640",
    d: "M924.421,24.566,926.64,22.5l2.082,2.435-2.431,1.85-1.871-2.217",
    transform: "translate(-867.012 -16.199)",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_641",
    "data-name": "Trazado 641",
    d: "M837.123,37.317l2.566,1.651-1.481,2.518-2.675-1.428,1.59-2.742",
    transform: "translate(-807.182 -26.174)",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_642",
    "data-name": "Trazado 642",
    d: "M939.239,40.521l-2.675,1.442-1.479-2.537,2.56-1.631,1.594,2.726",
    transform: "translate(-874.19 -26.496)",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_643",
    "data-name": "Trazado 643",
    d: "M830.467,58.111l-2.824-1.1,1.2-2.894,2.782,1.263-1.159,2.726",
    transform: "translate(-801.872 -37.485)",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_644",
    "data-name": "Trazado 644",
    d: "M824.606,75.552l-2.941-.816.916-2.979,2.883.951-.859,2.844",
    transform: "translate(-797.848 -49.355)",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_645",
    "data-name": "Trazado 645",
    d: "M819.348,184.8l-2.982.573-.532-3.067,3-.438c.169.974.328,1.886.511,2.933",
    transform: "translate(-793.923 -123.469)",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_646",
    "data-name": "Trazado 646",
    d: "M947.414,57.469l-2.822,1.1-1.181-2.722,2.777-1.268,1.227,2.891",
    transform: "translate(-879.793 -37.792)",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_647",
    "data-name": "Trazado 647",
    d: "M820.065,203.26l-.747-3.007,2.944-.7.751,2.9-2.948.813",
    transform: "translate(-796.268 -135.372)",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_648",
    "data-name": "Trazado 648",
    d: "M932.3,253.667l-2.413-1.863,1.662-2.385,2.565,1.631-1.815,2.617",
    transform: "translate(-870.693 -168.937)",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_649",
    "data-name": "Trazado 649",
    d: "M960.015,182.483l-.508,3.076-2.982-.539.466-2.92,3.024.383",
    transform: "translate(-888.62 -123.625)",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_650",
    "data-name": "Trazado 650",
    d: "M917.927,265.236l2.092-1.954,2.2,2.106-2.365,2.2-1.927-2.351",
    transform: "translate(-862.641 -178.268)",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_651",
    "data-name": "Trazado 651",
    d: "M870.168,278.032l-3.02-1.394,1.535-2.65,2.492,1.17-1.007,2.874",
    transform: "translate(-828.462 -185.474)",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_652",
    "data-name": "Trazado 652",
    d: "M955.327,94.036l-.62-2.917,2.969-.679.644,3.021-2.993.574",
    transform: "translate(-887.397 -61.931)",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_653",
    "data-name": "Trazado 653",
    d: "M832.552,237.708l-1.4-2.809,2.769-1.274,1.306,2.644-2.673,1.439",
    transform: "translate(-804.232 -158.306)",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_654",
    "data-name": "Trazado 654",
    d: "M899.464,4.153l-1.01,2.894-2.629-.595.337-3.013,3.3.715",
    transform: "translate(-847.764 -3.37)",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_655",
    "data-name": "Trazado 655",
    d: "M863.527,12.387,861.22,14,859.3,11.622l2.685-1.872,1.546,2.637",
    transform: "translate(-823.177 -7.619)",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_656",
    "data-name": "Trazado 656",
    d: "M842.716,249.293l1.662,2.392-2.416,1.846-1.822-2.6,2.576-1.636",
    transform: "translate(-810.283 -168.852)",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_657",
    "data-name": "Trazado 657",
    d: "M854.094,263.2l2.082,1.95L854.25,267.5l-2.373-2.189,2.216-2.1",
    transform: "translate(-818.183 -178.214)",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_658",
    "data-name": "Trazado 658",
    d: "M950.8,76.042l-.844-2.851,2.878-.962.9,2.979-2.932.834",
    transform: "translate(-884.2 -49.673)",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_659",
    "data-name": "Trazado 659",
    d: "M961.041,108.909l.359,3.062-3.006.332c-.123-.97-.238-1.881-.373-2.947l3.019-.447",
    transform: "translate(-889.628 -74.361)",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_660",
    "data-name": "Trazado 660",
    d: "M879.928,3.231c.112,1.158.2,2.106.3,3.059l-2.6.575L876.619,4.01l3.309-.779",
    transform: "translate(-834.837 -3.231)",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_233",
    "data-name": "Rect\\xE1ngulo 233",
    width: 2.915,
    height: 2.913,
    transform: "translate(21.143 46.672)",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_234",
    "data-name": "Rect\\xE1ngulo 234",
    width: 2.886,
    height: 2.951,
    transform: "translate(69.29 46.698)",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_661",
    "data-name": "Trazado 661",
    d: "M782.451,33.916a3.009,3.009,0,1,1-3.005-3.037,2.971,2.971,0,0,1,3.005,3.037",
    transform: "translate(-767.403 -21.84)",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_662",
    "data-name": "Trazado 662",
    d: "M994.242,33.94a3.01,3.01,0,1,1-2.981-3.061,2.969,2.969,0,0,1,2.981,3.061",
    transform: "translate(-909.957 -21.84)",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_663",
    "data-name": "Trazado 663",
    d: "M991.268,242.717a3.01,3.01,0,1,1-3.042,3,2.971,2.971,0,0,1,3.042-3",
    transform: "translate(-909.958 -164.426)",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_664",
    "data-name": "Trazado 664",
    d: "M779.478,242.717a3.01,3.01,0,1,1-3.043,3,2.972,2.972,0,0,1,3.043-3",
    transform: "translate(-767.404 -164.426)",
    fill: "#ffffff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEspecificas);
export default __webpack_public_path__ + "static/media/especificas.58a3537bccf53d0d59cc3a9da582db73.svg";
export { ForwardRef as ReactComponent };